export const FETCH_TAB_AND_FILTER = "FETCH_TAB_AND_FILTER";
export const FETCH_LIST = "TABLE_FETCH_LIST";
export const FETCH_DOWNLOAD_LIST = "TABLE_FETCH_DOWNLOAD_LIST";